<template>
  <div class="main-basic-info-data" v-if="dataLoadedCar">
    <span v-for="(item, i) in infoItems" :key="i" class="main-basic-info-data__item">
      <span class="main-basic-info-data__text">
        {{ item.name }} {{ item.val }} <span v-if="item.exp" v-html="item.exp"></span>
      </span>
    </span>
  </div>
  <div class="main-basic-info-data" v-else>
    <span class="main-basic-info-data__item" v-for="item in 4" :key="item">
      <span class="main-basic-info-data__text b-empty shine-short"></span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    car: {
      type: Object
    }
  },
  computed: {
    dataLoadedCar() {
      return this.$store.getters.carLoaded;
    },
    engine() {
      return parseInt(this.car.engine < 10 ? this.car.engine * 1000 : this.car.engine).format()
    },
    infoItems() {
      let res = [];

      if (this.car.engine && this.car.engine > 0) {
        res.push({
          name: 'Slagrými',
          val: this.car.engine,
          exp: 'cc.'
        })
      }

      if (this.car.accelaration && this.car.accelaration > 0) {
        res.push({
          name: 'Hröðun 0-100 km/klst',
          val: this.car.accelaration,
          exp: '<sub>sek</sub>'
        })
      }

      if (this.car.horse_power && this.car.horse_power > 0) {
        res.push({
          val: this.car.horse_power,
          exp: 'hestafl'
        })
      }

      if (this.car.consumption && this.car.consumption > 0) {
        res.push({
          name: 'Eyðsla',
          val: this.car.consumption,
          exp: this.car.fuel_filter_id == 2?'<sub>kWh/100km</sub>':'<sub>L/100km</sub>'
        })
      }

      if (this.car.tog && this.car.tog > 0) {
        res.push({
          val: this.car.tog,
          exp: 'tog'
        })
      }

      if (this.car.seats_number && this.car.seats_number > 0) {
        res.push({
          name: 'Sætafjöldi',
          val: this.car.seats_number,
        })
      }

      if (this.car.towing_capacity && this.car.towing_capacity > 0) {
        res.push({
          name: 'Dráttargetan',
          val: this.car.towing_capacity,
          exp:'kg'
        })
      }


      if (this.car.co2 && this.car.co2 > 0) {
        res.push({
          name: 'CO2',
          val: this.car.co2,
          exp: 'gr/km'
        });
      }

      /*      if(this.car.horse_power){
              res.push({
                name:'Horse power',
                val:this.car.horse_power
              })
            }*/
/*
      if (this.car.model_year) {
        res.push({
          name: 'Model year',
          val: this.car.model_year
        })
      }*/

      if (this.car.battery_capacity && this.car.battery_capacity > 0) {
        res.push({
          name: 'Stærð rafhlöðu',
          val: this.car.battery_capacity,
          exp: 'kWh'
        })
      }

      if (this.car.affinity && this.car.affinity > 0) {
        res.push({
          name: 'Drægni allt að',
          val: this.car.affinity,
          exp: 'km'
        })
      }

      return res;
    }
  }
};
</script>